import { render, staticRenderFns } from "./JurisdictionsTable.vue?vue&type=template&id=4902b089&scoped=true"
import script from "./JurisdictionsTable.vue?vue&type=script&lang=js"
export * from "./JurisdictionsTable.vue?vue&type=script&lang=js"
import style0 from "./JurisdictionsTable.vue?vue&type=style&index=0&id=4902b089&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4902b089",
  null
  
)

export default component.exports